export default "__VITE_ASSET__D6ZP1XCS__"